import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useReducer,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col, Typography, notification } from 'antd';
import {
  ChatInputBar,
  ChatHeader,
  ChatMinimizeList,
  ChatThread,
  ScrollButton,
} from './components';

import { LoadingOutlined } from '@ant-design/icons';

import classnames from 'classnames';

import Thread from './ui/communication/Thread';
import * as chatSelectors from './controller/selectors';
import * as chatActions from './controller/actions';
import * as globalActions from '@redux/global/actions';
import * as globalSelectors from '@redux/global/selectors';
import userSelectors from '@redux/user/selectors';
import * as userActions from '@redux/user/actions';

import * as memberSelectors from 'pages/company-profile/controllers/selectors';
import * as memberActions from 'pages/company-profile/controllers/actions';

import * as servicesChat from 'services/chatServices';
import * as extChatSerices from 'services/ext-chat';

import { WithLoading } from 'common/components';
import CreateNewThreadModal from './ui/MaximizeChatView/CreateNewThreadModal';
import CreateNewThreadPrivate from './ui/MaximizeChatView/CreateNewThreadPrivate';
import AddRemoveThreadModal from './ui/MaximizeChatView/AddRemoveThreadModal';
import { useCheckPermissionOR } from 'hooks/useCheckPermissions';
import { SECURE_CONFIG } from 'utils/SecureRoute';

import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';
import { useCheckPermissions } from 'hooks/useCheckPermissions';
import { getAnonToken } from 'utils/common/session';

import {
  attachmentReducer,
  attachmentActions,
  defaultStateAttachment,
} from './components/fields/hooks';
import { checkInvalidFile, findAccount } from './components/fields/utils';

import useUpdateContactCard from 'hooks/useUpdateContactCard';

import RIVIR_LOGO from 'assets/VAULT_LOGO_BLACK.png';

import * as _ from 'lodash';

import './Chat.less';

const CHAT_CALL_VIDEO_VIA_PERSONAL_ACCOUNT = [
  {
    action: ABILITY_ACTION.CHAT,
    subject: ABILITY_SUBJECT.CHAT_COMPANY,
  },
];
const CHAT_CALL_VIDEO_VIA_COMPANY_ACCOUNT = [
  {
    action: ABILITY_ACTION.CHAT,
    subject: ABILITY_SUBJECT.CHAT_PERSONAL,
  },
];

const MAX_NUMBER_OF_FILES = 6;

//* move to init reducer
// const key = 'chat';

var debounceSearch;

const Chat = (props) => {
  const {
    isVideoCallOpen,
    isReceivingCall,
    videoCall,
    isVideoCallChat = false,
    forceSenderId,
  } = props;
  const hasPersonalChatPermission = useCheckPermissions(
    CHAT_CALL_VIDEO_VIA_PERSONAL_ACCOUNT
  );
  const hasCompanyChatPermission = useCheckPermissions(
    CHAT_CALL_VIDEO_VIA_COMPANY_ACCOUNT
  );

  const disableCameraBtn =
    isVideoCallOpen || isReceivingCall || isVideoCallChat;

  const scroller = useRef(null);

  const updateContactCard = useUpdateContactCard();

  //* move to init reducer
  // useInjectReducer({ key, reducer: chatReducer });
  // useInjectSaga({ key, saga: chatSaga });

  const [textSearch, setTextSearch] = useState('');
  const [filterSearch, setFilterSearch] = useState(['member', 'user']);
  const [chatText, setChatText] = useState('');
  const [attachList, setAttachList] = useState([]);
  const [hasNewMsg, setHasNewMsg] = useState(false);

  // Warning messages
  const [warningMessage, setWarningMessage] = useState(null);
  const warningRef = useRef(null);

  const [hasNewMsgNotify, setHasNewMsgNotify] = useState(false);

  const [maximizeChatView, setMaximizeChatView] = useState(false);
  const [groupUsers, setGroupUsers] = useState([]);
  const [isClickInputChat, setIsClickInputChat] = useState(false);
  const [isClickMessageBox, setIsClickMessageBox] = useState(false);

  const [shouldShowScrollBtn, setShouldShowScrollButton] = useState(false);
  const [requestThreadInfo, setRequestThreadInfo] = useState({});

  const [isCreate, setIsCreate] = useState(false);
  const [isCreatePrivate, setIsCreatePrivate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const dispatch = useDispatch();

  const communicationList = useSelector(
    chatSelectors.selectCommunicationList()
  );

  const communicationItemData = useSelector(chatSelectors.selectThreadInfo());
  const statusThreadInfo = useSelector(chatSelectors.selectStatusThreadInfo());
  const threadInfoError = useSelector(chatSelectors.selectThreadInfoError());
  const threadMessages = useSelector(chatSelectors.selectThreadMessages());
  const isFinishLoadDown = useSelector(chatSelectors.selectFinishLoadDown());
  const latestMessage = useSelector(chatSelectors.selectLastMessage());
  const isFocusChat = useSelector(chatSelectors.selectIsFocusChat());

  const communicationListData = communicationList?.data;
  const communicationListLoading = communicationList?.loading;
  const communicationListHasMore = communicationList?.hasMore;
  const communicationListLoadingMore = communicationList?.loadingMore;

  const showMinimizedThreadList = useSelector(
    chatSelectors.selectShowMinimizedThreadList()
  );
  const toggleChatBox = useSelector(chatSelectors.selectToggleChatBox());

  const minimizedChatThreadList = useSelector(
    chatSelectors.selectMinimizedChatThreadList()
  );

  const newMsgInfo = useSelector(globalSelectors.selectNewMsgInfo());
  const userID = useSelector(userSelectors.makeSelectUserId());
  const memberID = useSelector(userSelectors.makeSelectUserMemberId());
  const toggleNewMessage = useSelector(chatSelectors.selectToggleNewMessage());
  const unreadMsgList = useSelector(chatSelectors.selectUnreadMessages());
  const selectedSearchResultPosition = useSelector(
    chatSelectors.selectSelectedSearchResultPosition()
  );
  const activeThread = useSelector(chatSelectors.selectActiveThreadInfo());
  const view = useSelector(chatSelectors.selectChatView());

  const userInfo = useSelector(userSelectors.makeSelectUserInfo());

  const checkGetListAfterSendMessage = useSelector(
    globalSelectors.selectCheckGetListAfterSendMessage()
  );

  const contactCardInfo = useSelector(
    userSelectors.makeSelectContactCardInfo()
  );

  const userProfileHeader = useSelector(
    userSelectors.makeSelectUserProfileHeader()
  );

  const memberInfo = useSelector(memberSelectors.selectMemberProfile());

  const checkPermission = useCheckPermissionOR();
  const canChatPersonal = checkPermission(SECURE_CONFIG.CHAT_PERSONAL.PASS);
  const canChatCompany = checkPermission(SECURE_CONFIG.CHAT_COMPANY.PASS);

  const [attachmentState, attachmentDispatch] = useReducer(
    attachmentReducer,
    defaultStateAttachment
  );

  const setIsFocusChat = (status) => {
    dispatch(chatActions.setIsFocusChat(status));
  };

  const setView = (viewName) => {
    dispatch(chatActions.setChatView(viewName));
  };

  useEffect(() => {
    if (requestThreadInfo?.threadId && threadInfoError) {
      notification.error({
        message: threadInfoError,
      });
      dispatch(chatActions.updateThreadInfoError());
    }
  }, [dispatch, threadInfoError, requestThreadInfo?.threadId]);

  useEffect(() => {
    if (
      communicationItemData?.id &&
      requestThreadInfo?.threadId &&
      requestThreadInfo?.creatorId &&
      communicationItemData?.id === requestThreadInfo?.threadId
    ) {
      updateCommunicationThreadListWhenInitChat(
        requestThreadInfo?.threadId,
        requestThreadInfo?.creatorId
      );
    }

    if (!_.isEmpty(communicationItemData)) {
      onCheckActiveThreadAndCommunicationItem(
        communicationItemData,
        activeThread
      );
    }
  }, [
    communicationItemData?.id,
    requestThreadInfo?.threadId,
    requestThreadInfo?.creatorId,
  ]);

  useEffect(() => {
    if (view === 'threadList') {
      setIsFocusChat(false);
    }
  }, [view]);

  const handleClickMinimizeBtn = () => {
    // if (!communicationItemData) dispatch(chatActions.minimizeChat());
    if (view === 'threadList') dispatch(chatActions.minimizeChat());
    else minimizeChatThread();
  };

  const minimizeChatThread = () => {
    dispatch(globalActions.setNewMsgInfo(null));
    const isAdded = checkThreadAdded();
    if (!isAdded) addChatListToMinimizedList();
    handleClickBackBtn();
  };

  const checkThreadAdded = () => {
    return minimizedChatThreadList?.find((thread) => {
      return thread?.id === communicationItemData?.id;
    });
  };

  const addChatListToMinimizedList = () => {
    const minimizedChatThreadListClone = _.cloneDeep(minimizedChatThreadList);
    minimizedChatThreadListClone.unshift(communicationItemData);

    dispatch(chatActions.minimizeChatThread(minimizedChatThreadListClone));
  };

  const handleClickBackBtn = () => {
    setMakeThreadAsRead();
    if (communicationItemData) {
      scrollToTop();
      //* NOTICE : this action will be called after user click to thread item
      // dispatch(chatActions.getThreadInfoSuccess(null));

      setView('threadList');
      onGetCommunicationList(filterSearch, textSearch, 1, 20);
    }
    dispatch(chatActions.resetStatusThreadInfo());
    dispatch(chatActions.resetStatusMsgThread());

    //! NOTICE: this line of code will be removed if it does not produce any bugs
    // dispatch(chatActions.saveAccountChat(null));

    dispatch(chatActions.saveActiveThreadInfo(null));
    dispatch(chatActions.setUnreadMessages([]));
    if (chatText) {
      setChatText('');
    }

    dispatch(chatActions.resetThreadInfo());
  };

  const setMakeThreadAsRead = () => {
    if (unreadMsgList?.length === 0 && !_.isEmpty(activeThread)) {
      const payload = {
        userId: activeThread?.userId,
        threadId: activeThread?.threadId,
      };
      dispatch(globalActions.makeAThreadAsRead(payload));
    }
  };

  const handleChangeSearchBar = (event) => {
    setTextSearch(event.target.value);
    handleSearch(event.target.value, filterSearch);
  };

  const handleChangeFilter = (filter) => {
    setFilterSearch(filter);
    handleSearch(textSearch, filter);
  };

  const handleClickBackSearchBar = (event) => {
    setTextSearch('');
    handleSearch('', filterSearch);
  };

  const handleSearch = (value, filter) => {
    dispatch(chatActions.getCommunicationListFail(null));
    if (debounceSearch) clearTimeout(debounceSearch);
    debounceSearch = setTimeout(() => {
      onGetCommunicationList(filter, value, 1, 20);
    }, 500);
  };

  const getAttachFile = (uniqueFilesState) => {
    const { data: uniqueFiles, action, removedFileId } = uniqueFilesState;

    if (action === 'none') {
      setAttachList([]);
      attachmentDispatch({
        type: attachmentActions.RESET,
      });
      return;
    }

    if (action === 'add') {
      if (checkInvalidFile(uniqueFiles)) {
        setWarningMessage(
          `Your uploaded file size exceeds the allowed limit. Maximum file size is 10MB`
        );
        warningRef.current.onClick();
        return;
      }

      if (
        uniqueFiles.length + attachmentState.attachment.length >
        MAX_NUMBER_OF_FILES
      ) {
        setWarningMessage(`Maximum number of files is ${MAX_NUMBER_OF_FILES}`);
        warningRef.current.onClick();
        return;
      }
      setAttachList((prevFiles) => prevFiles.concat(uniqueFiles));
      attachmentDispatch({
        type: attachmentActions.SAVE_ATTACHMENT,
        newAttachment: uniqueFiles,
      });
    }

    if (action === 'remove') {
      setAttachList((prevFiles) =>
        prevFiles.filter((file) => file.uid !== removedFileId)
      );
      attachmentDispatch({
        type: attachmentActions.REMOVE_ATTACHMENT,
        fileUid: removedFileId,
      });
    }
  };

  const onChangeChatInput = useCallback((message) => {
    !isFocusChat && setIsFocusChat(true);
    setChatText(message);
  }, []);

  const handleScroll = () => {
    const scrollEl = scroller.current;
    const scrollPos = scrollEl.scrollTop;
    const viewHeight = scrollEl.offsetHeight;
    const scrollHeight = scrollEl.scrollHeight;

    if (scrollPos >= scrollHeight - viewHeight - 10) {
      setShouldShowScrollButton(false);
      dispatchScrollBottomEvent(scrollPos);
    }

    if (scrollPos < scrollHeight - viewHeight - 100) {
      setShouldShowScrollButton(true);
    }
  };

  const dispatchScrollBottomEvent = (scrollPos) => {
    if (window.chatScrollPos < scrollPos) {
      const event = new CustomEvent('chatScrollBottom', {
        detail: {
          threadMessages,
          isFinishLoadDown,
        },
      });

      document.dispatchEvent(event);
    }
    window.chatScrollPos = scrollPos;
  };

  const scrollToBottom = React.useCallback(() => {
    if (!scroller.current) return;

    const scrollerHeight = scroller.current.scrollHeight;

    scroller.current.scrollTop = scrollerHeight;
  }, [scroller]);

  const scrollToTop = React.useCallback(() => {
    if (!scroller.current) return;

    scroller.current.scrollTop = 0;
  }, []);

  const scrollToMessage = () => {
    if (!selectedSearchResultPosition) return;

    const scroll = scroller.current;
    const viewHeight = scroll.offsetHeight;
    scroll.scrollTop = selectedSearchResultPosition - viewHeight / 2;

    // const scrollDestination = selectedSearchResultPosition - viewHeight + 40;

    // if (scrollDestination < 0) {
    //   scroll.scrollTop = 0;
    //   return;
    // }

    // const currentScrollPosition = scroll.scrollTop;

    // const isOutsideView =
    //   scrollDestination > currentScrollPosition ||
    //   scrollDestination < currentScrollPosition - viewHeight;

    // if (isOutsideView) scroll.scrollTop = scrollDestination;
  };

  const onCloseChatView = () => {
    dispatch(globalActions.toggleChatView(false));
    dispatch(globalActions.getEmailAndMessageNotify());
    dispatch(chatActions.resetStatusThreadInfo());
    dispatch(chatActions.resetStatusMsgThread());
    dispatch(chatActions.saveAccountChat(null));
    dispatch(chatActions.saveActiveThreadInfo(null));
    dispatch(chatActions.resetChatView());
  };

  const onMaximizeChatView = (maximize) => {
    setMaximizeChatView(maximize);
  };

  const onClickInputMsg = (status) => {
    setIsClickInputChat(status);
  };

  const onClickMessageBox = (status) => {
    setIsClickMessageBox(status);
  };

  useEffect(() => {
    if (isClickInputChat || isClickMessageBox) {
      setIsFocusChat(true);
    } else {
      setIsFocusChat(false);
    }
  }, [isClickInputChat, isClickMessageBox]);

  /**
   *
   * @param {*} communicationItem : communicationItemData
   * @param {*} currentActiveThread : get from chatSelectors.selectActiveThreadInfo()
   */
  const onCheckActiveThreadAndCommunicationItem = (
    communicationItem,
    currentActiveThread
  ) => {
    if (communicationItem?.id !== currentActiveThread?.threadId) {
      onSetCurrentActiveThread(communicationItemData, currentActiveThread);
    }
  };

  /**
   *
   * @param {*} communicationItem : communicationItemData
   * @param {*} currentActiveThread : get from chatSelectors.selectActiveThreadInfo()
   */
  const onSetCurrentActiveThread = (communicationItem, currentActiveThread) => {
    let threadTemp = {
      ...communicationItem,
      threadId: communicationItem?.id,
    };

    const { accountUser, accountCompany } = findAccount(
      communicationItem?.users,
      userID,
      memberID
    );

    if (accountUser) {
      threadTemp = { ...threadTemp, userId: accountUser?.userId };
    }
    if (accountCompany) {
      threadTemp = { ...threadTemp, userId: accountCompany?.userId };
    }

    //final
    dispatch(chatActions.saveActiveThreadInfo(threadTemp));
  };

  const chatView = () => {
    const isShowCommunicationList = _.isEmpty(communicationItemData);

    if (maximizeChatView) {
      return (
        <Row>
          <Col
            className='scroller-extend'
            // ref={scroller}
            span={8}
            style={{
              height: 'calc(100vh - 148px)',
              borderRight: '1px solid #ccc',
              padding: 8,
              background: '#f0f4f8',
            }}
          >
            <Thread
              communicationListData={communicationListData}
              communicationItemData={communicationItemData}
              communicationListLoading={communicationListLoading}
              getThreadListMore={getThreadListMore}
              communicationListHasMore={communicationListHasMore}
              communicationListLoadingMore={communicationListLoadingMore}
              setView={setView}
            />
          </Col>

          <Col
            span={16}
            style={{
              height: 'calc(100vh - 148px)',
              padding: 8,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div style={{ overflow: 'hidden', position: 'relative', flex: 1 }}>
              <div
                className='scroller-extend'
                ref={scroller}
                style={{ flex: '1 auto', height: '100%' }}
                onScroll={handleScroll}
              >
                {isShowCommunicationList && statusThreadInfo !== 'loading' ? (
                  <>
                    <Row style={{ justifyContent: 'center' }}>
                      <img src={RIVIR_LOGO} />
                    </Row>
                    <Row style={{ justifyContent: 'center' }}>
                      <Typography.Title level={1}>
                        COMMUNICATION SYSTEM
                      </Typography.Title>
                    </Row>
                  </>
                ) : (
                  <WithLoading
                    loading={statusThreadInfo === 'loading'}
                    indicator={<LoadingOutlined />}
                  >
                    <ChatThread
                      data={threadMessages}
                      participants={groupUsers}
                      threadId={communicationItemData?.id}
                      scroller={scroller.current}
                      shouldShowScrollBtn={shouldShowScrollBtn}
                      scrollToBottom={scrollToBottom}
                      toggleNewMessage={toggleNewMessage}
                      isFocusChat={isFocusChat}
                      onClickMessageBox={onClickMessageBox}
                    />
                  </WithLoading>
                )}
              </div>

              <ScrollButton
                threadId={communicationItemData?.id}
                toggleNewMessage={unreadMsgList}
                scrollToBottom={scrollToBottom}
                shouldShowScrollBtn={shouldShowScrollBtn}
                threadMessages={threadMessages}
                latestMessage={latestMessage}
              />
            </div>
            <ChatInputBar
              value={chatText}
              attachList={attachList}
              getAttachFile={getAttachFile}
              setAttachList={setAttachList}
              onChangeChatInput={onChangeChatInput}
              show={!!communicationItemData}
              disabledCamera={disableCameraBtn}
              highlightCameraBtn={isReceivingCall}
              groupUsers={groupUsers}
              maximizeChatView={maximizeChatView}
              onClickInputMsg={onClickInputMsg}
              attachmentDispatch={attachmentDispatch}
              attachmentState={attachmentState}
              warningMessage={warningMessage}
              warningRef={warningRef}
            />
          </Col>
        </Row>
      );
    }

    return (
      <>
        <div style={{ overflow: 'hidden', position: 'relative', flex: 1 }}>
          <div
            className='scroller-extend'
            ref={scroller}
            style={{ flex: '1 auto', height: '100%', padding: 8 }}
            onScroll={handleScroll}
          >
            {(statusThreadInfo === 'idle' || statusThreadInfo === 'error') &&
            !isVideoCallChat ? (
              <Thread
                communicationListData={communicationListData}
                communicationListLoading={communicationListLoading}
                getThreadListMore={getThreadListMore}
                communicationListHasMore={communicationListHasMore}
                communicationListLoadingMore={communicationListLoadingMore}
                setView={setView}
              />
            ) : statusThreadInfo === 'loading' ? (
              <WithLoading
                loading={statusThreadInfo === 'loading'}
                indicator={<LoadingOutlined />}
              >
                <Thread
                  communicationListData={communicationListData}
                  communicationListLoading={communicationListLoading}
                  getThreadListMore={getThreadListMore}
                  communicationListHasMore={communicationListHasMore}
                  communicationListLoadingMore={communicationListLoadingMore}
                />
              </WithLoading>
            ) : (
              <ChatThread
                data={threadMessages}
                participants={groupUsers}
                threadId={communicationItemData?.id}
                scroller={scroller.current}
                shouldShowScrollBtn={shouldShowScrollBtn}
                scrollToBottom={scrollToBottom}
                toggleNewMessage={toggleNewMessage}
                isFocusChat={isFocusChat}
                onClickMessageBox={onClickMessageBox}
                view={view}
              />
            )}
          </div>
          {!isShowCommunicationList && (
            <ScrollButton
              toggleNewMessage={unreadMsgList}
              scrollToBottom={scrollToBottom}
              shouldShowScrollBtn={shouldShowScrollBtn}
              threadId={communicationItemData?.id}
              threadMessages={threadMessages}
              latestMessage={latestMessage}
            />
          )}
        </div>
        <ChatInputBar
          value={chatText}
          attachList={attachList}
          setAttachList={setAttachList}
          getAttachFile={getAttachFile}
          onChangeChatInput={onChangeChatInput}
          show={!!communicationItemData}
          disabledCamera={disableCameraBtn}
          highlightCameraBtn={isReceivingCall}
          groupUsers={groupUsers}
          maximizeChatView={maximizeChatView}
          onClickInputMsg={onClickInputMsg}
          attachmentDispatch={attachmentDispatch}
          attachmentState={attachmentState}
          warningMessage={warningMessage}
          warningRef={warningRef}
          isVideoCallChat={isVideoCallChat}
          forceSenderId={forceSenderId}
        />

        {/* todo: open this when finish ? */}
        {/* <StarRating rating={5} />
        <Comment comment={comment} /> */}
      </>
    );
  };

  useEffect(() => {
    onGetCommunicationList(filterSearch, textSearch, 1, 20);

    if (_.isEmpty(contactCardInfo)) {
      dispatch(userActions.getUserProfileHeader(userInfo?.id));
    }

    if (_.isEmpty(memberInfo)) {
      dispatch(memberActions.getMemberProfileHeader(userInfo?.member?.id));
    }
  }, []);

  const updateContactCardInfo = (data) => {
    updateContactCard(data);
  };

  // get user profile info when component mount
  useEffect(() => {
    if (!_.isEmpty(userProfileHeader)) updateContactCardInfo(userProfileHeader);
  }, [userProfileHeader]);

  useEffect(() => {
    if (checkGetListAfterSendMessage) {
      // onGetCommunicationList(filterSearch, textSearch, 1, 20);
      setRequestThreadInfo(checkGetListAfterSendMessage);
      dispatch(globalActions.updateListAfterSendMessage(false));
    }
  }, [checkGetListAfterSendMessage]);

  useEffect(() => {
    return () => {
      if (!isVideoCallChat && !isVideoCallOpen) {
        onDestruction();
      }
    };
  }, [isVideoCallChat, isVideoCallOpen]);

  useEffect(() => {
    scrollToMessage();
  }, [selectedSearchResultPosition]);

  const onGetCommunicationList = (
    filterArr,
    searchText,
    pageIndex,
    pageSize
  ) => {
    //* if user is anonymous. dont get thread list
    const anonToken = getAnonToken();
    if (anonToken) return;

    const shouldGetCompanyChat =
      canChatCompany && filterArr.indexOf('member') > -1 ? true : false;
    const shouldGetPrivateChat =
      canChatPersonal && filterArr.indexOf('user') > -1 ? true : false;

    const request = {
      GetEmail: false,
      GetChatMessage: true,
      GetCompanyThread: shouldGetCompanyChat,
      GetExternalThread: true,
      GetPrivateThread: shouldGetPrivateChat,

      PageIndex: pageIndex,
      PageSize: pageSize,
      SearchText: searchText,
    };

    dispatch(chatActions.getCommunicationList(request));
  };

  const onDestruction = () => {
    dispatch(chatActions.getThreadInfoSuccess(null));
    dispatch(chatActions.getThreadMessagesSuccess([]));
    dispatch(chatActions.getCommunicationListSuccess(null));
    dispatch(chatActions.getCommunicationDetailSuccess(null));
  };

  const getThreadListMore = (page) => {
    onGetCommunicationListMore(filterSearch, textSearch, page, 20);
  };

  const onGetCommunicationListMore = (
    filterArr,
    searchText,
    pageIndex,
    pageSize
  ) => {
    const request = {
      GetEmail: false,
      GetChatMessage: true,
      GetCompanyThread: filterArr.indexOf('member') > -1 ? true : false,
      GetExternalThread: true,
      GetPrivateThread: filterArr.indexOf('user') > -1 ? true : false,

      PageIndex: pageIndex,
      PageSize: pageSize,
      SearchText: searchText,
    };

    dispatch(chatActions.getCommunicationListMore(request));
  };

  useEffect(() => {
    if (!_.isEmpty(newMsgInfo)) {
      onUpdateThreadListWhenHavingNewMsg();
      onHasNewMsg();
      setHasNewMsgNotify(true);
    }
  }, [JSON.stringify(newMsgInfo)]);

  const onHasNewMsg = () => {
    setHasNewMsg(true);

    setTimeout(() => {
      setHasNewMsg(false);
    }, 2000);
  };

  // useEffect(() => {
  //   if (maximizeChatView) {
  //     dispatch(chatActions.getThreadListForSupporter());
  //     dispatch(chatActions.getChatContentDetail('1'));
  //   }
  // }, [maximizeChatView]);

  useEffect(() => {
    if (communicationItemData?.users?.length > 0) {
      let userIds = onSetListUserIds(communicationItemData?.users);
      onGetUsersInfo(userIds);
    }
  }, [JSON.stringify(communicationItemData?.users)]);

  const onSetListUserIds = (users) => {
    return users.map((user) => user.userId);
  };

  const onGetUsersInfo = (userIds) => {
    const anonToken = getAnonToken();

    const getChatUserInfoServices = anonToken
      ? extChatSerices.anonGetChatUsersInfo
      : servicesChat.getChatUsersInfo;

    getChatUserInfoServices(userIds)
      .then((res) => {
        if (res.isSuccess) {
          onSetUsersInfo(communicationItemData?.users, res.data.senders);
        } else {
          onSetUsersInfo(communicationItemData?.users);
        }
        // setGroupUsers(res.data);
      })
      .catch((err) => console.log('err ', err));
  };

  /*
  /* info1: info in thread-info
  /*  info2: info in users-info
  */
  const onSetUsersInfo = (info1, info2) => {
    if (info2.length > 0) {
      const users = info1.map((info) => {
        let data = info2.find(
          (firstInfo) => firstInfo.senderId === info.userId
        );
        return Object.assign({}, info, data);
      });

      setGroupUsers(users);
    } else {
      setGroupUsers(info1);
    }
  };

  const onUpdateThreadListWhenHavingNewMsg = async () => {
    let result;

    if (!_.isEmpty(newMsgInfo) && _.isArray(communicationListData)) {
      result =
        communicationListData?.length > 0 ? [...communicationListData] : [];
      const existedThread = result?.filter(
        (thread) => thread.threadId === newMsgInfo?.threadId
      );
      const threads = result?.filter(
        (thread) => thread.threadId !== newMsgInfo?.threadId
      );
      if (existedThread?.length > 0) {
        const newThreads = existedThread.map((thread) => {
          return {
            ...thread,
            lastMessageText: newMsgInfo?.messageText,
            lastMessageTime: newMsgInfo?.sendTime,
            readStatus: isFocusChat ? true : false,
          };
        });
        dispatch(
          chatActions.updateCommunicationThreadList([...newThreads, ...threads])
        );
      } else {
        let tempThreadInfoList = [];
        if (hasPersonalChatPermission) {
          const personalResponse = await onGetThreadInfo(
            newMsgInfo?.threadId,
            `U-${userID}`
          );
          let userThreadInfo =
            personalResponse?.isSuccess && personalResponse?.data
              ? personalResponse?.data
              : null;
          if (userThreadInfo) {
            tempThreadInfoList = [
              {
                ...userThreadInfo,
                lastMessageText: newMsgInfo?.messageText,
                readStatus: isFocusChat ? true : false,
                threadId: newMsgInfo?.threadId,
                userId: `U-${userID}`,
                uniqueId: `U-${userID}-${userThreadInfo?.id}`,
              },
            ];
          }
        }
        if (hasCompanyChatPermission) {
          const companyResponse = await onGetThreadInfo(
            newMsgInfo?.threadId,
            `C-${memberID}`
          );
          let companyThreadInfo =
            companyResponse?.isSuccess && companyResponse?.data
              ? companyResponse?.data
              : null;
          if (companyThreadInfo) {
            const companyThreadInfoArray = [
              {
                ...companyThreadInfo,
                lastMessageText: newMsgInfo?.messageText,
                readStatus: isFocusChat ? true : false,
                threadId: newMsgInfo?.threadId,
                userId: `C-${memberID}`,
                uniqueId: `C-${memberID}-${companyThreadInfo?.id}`,
              },
            ];
            tempThreadInfoList = [
              ...tempThreadInfoList,
              ...companyThreadInfoArray,
            ];
          }
        }
        result =
          tempThreadInfoList?.length > 0
            ? [...tempThreadInfoList, ...result]
            : result;
        dispatch(chatActions.updateCommunicationThreadList(result));
      }
    }
  };

  const updateCommunicationThreadListWhenInitChat = (threadId, creatorId) => {
    let result =
      communicationListData?.length > 0 ? [...communicationListData] : [];

    const existedThread = result?.find(
      (thread) => thread.threadId === threadId
    );
    if (existedThread) {
      result = _.sortBy(result, ({ threadId }) =>
        threadId === existedThread?.threadId ? 0 : 1
      );
    } else if (
      !existedThread &&
      threadId &&
      communicationItemData?.id &&
      threadId === communicationItemData?.id
    ) {
      result.unshift({
        ...communicationItemData,
        threadId: communicationItemData?.id,
        userId: creatorId,
        uniqueId: `${creatorId}-${communicationItemData?.id}`,
      });
    }
    dispatch(chatActions.updateCommunicationThreadList(result));
  };

  const onGetThreadInfo = (threadId, userId) => {
    const params = {
      ThreadId: threadId,
      UserId: userId,
    };
    return servicesChat.getThreadInfo(params);
  };

  return (
    <>
      <div
        className={classnames({
          chat__container: !maximizeChatView,
          'chat__container--wide': toggleChatBox && !maximizeChatView,
          'chat__container--minimize':
            showMinimizedThreadList && !maximizeChatView,

          'chat-maximize__container': maximizeChatView,
          'chat__container--video-call': isVideoCallChat,
        })}
      >
        <div
          className={classnames({
            chat: !maximizeChatView,
            'chat--minimized':
              !toggleChatBox && !maximizeChatView && !isVideoCallChat,
            'chat--offset': !maximizeChatView && !isVideoCallChat,

            'chat-maximize': maximizeChatView,
            'chat-maximize--hidden': !toggleChatBox && maximizeChatView,
          })}
        >
          {!isVideoCallChat && (
            <ChatHeader
              maximizeChatView={maximizeChatView}
              info={communicationItemData}
              groupUsers={groupUsers}
              communicationListData={communicationListData}
              isInChatThread={!!communicationItemData && view === 'threadMsg'}
              isShowBackButton={!!communicationItemData}
              filterSearch={filterSearch}
              onClickBackBtn={handleClickBackBtn}
              onChangeSearchBar={handleChangeSearchBar}
              onClickBackSearchBar={handleClickBackSearchBar}
              textSearch={textSearch}
              onClickMinimizeBtn={handleClickMinimizeBtn}
              onCloseChatView={onCloseChatView}
              onChangeFilter={handleChangeFilter}
              onMaximizeChatView={onMaximizeChatView}
              participants={groupUsers}
              newChatThread={() => setIsCreate(true)}
              newChatPrivate={() => {
                setIsCreatePrivate(true);
              }}
              editThread={() => {
                setIsEdit(true);
              }}
            />
          )}
          {chatView()}
        </div>
        {!isVideoCallChat && (
          <ChatMinimizeList
            className={classnames({
              chat__minimize: true,
              'chat__minimize--showing': true,
            })}
            communicationItemData={communicationItemData}
            minimizedChatThreadList={minimizedChatThreadList}
            toggleChatBox={toggleChatBox}
            hasNewMsg={hasNewMsg}
            hasNewMsgNotify={hasNewMsgNotify}
            newMsgInfo={newMsgInfo}
            onCloseChatView={onCloseChatView}
            view={view}
            setView={setView}
          />
        )}
        <CreateNewThreadModal
          visible={isCreate}
          closeNewChat={() => setIsCreate(false)}
          communicationListData={communicationListData}
          setRequestThreadInfo={setRequestThreadInfo}
        />
        <CreateNewThreadPrivate
          visible={isCreatePrivate}
          closeNewChat={() => setIsCreatePrivate(false)}
          setRequestThreadInfo={setRequestThreadInfo}
        />
        <AddRemoveThreadModal
          visible={isEdit}
          closeNewChat={() => setIsEdit(false)}
          groupUsers={groupUsers}
          info={communicationItemData}
          videoCall={videoCall}
        />
      </div>
    </>
  );
};

export default Chat;
